export default __webpack_public_path__ + "static/media/72.ef86927e.jpg";